import React, { useEffect, useState } from 'react';
import ReactJson from 'react-json-view';

const JsonPreviewer = ({ url }) => {
  const [jsonData, setJsonData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchJsonData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch JSON from ${url}`);
        }
        const data = await response.json();
        setJsonData(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchJsonData();
  }, [url]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div style={{ width: '100%', height: '100%', overflow: 'auto', padding:'2rem' }}>
      {jsonData ? (
        <ReactJson 
          src={jsonData} 
          onSelect={(r) => console.log('Selected:', r)}
          collapsed={false}
          enableClipboard={true}
        />
      ) : (
        <div>Loading JSON data...</div>
      )}
    </div>
  );
};

export default JsonPreviewer;